import dayjs from "dayjs";

export function getBirthDateFromPesel(pesel: string): string | undefined {
  if (!/^\d{11}$/.test(pesel)) {
    return undefined;
  }

  const yearPart = parseInt(pesel.substring(0, 2), 10);
  const monthPart = parseInt(pesel.substring(2, 4), 10);
  const dayPart = parseInt(pesel.substring(4, 6), 10);

  if (dayPart < 1 || dayPart > 31) {
    return undefined;
  }

  let century = 1900;
  let month = monthPart;
  if (month >= 1 && month <= 12) {
    century = 1900;
  } else if (month >= 21 && month <= 32) {
    century = 2000;
    month -= 20;
  } else if (month >= 41 && month <= 52) {
    century = 2100;
    month -= 40;
  } else if (month >= 61 && month <= 72) {
    century = 2200;
    month -= 60;
  } else if (month >= 81 && month <= 92) {
    century = 1800;
    month -= 80;
  } else {
    return undefined;
  }

  const fullYear = century + yearPart;

  const birthDate = new Date(fullYear, month - 1, dayPart);

  if (
    birthDate.getFullYear() !== fullYear ||
    birthDate.getMonth() !== month - 1 ||
    birthDate.getDate() !== dayPart
  ) {
    return undefined;
  }

  return dayjs(birthDate).format("YYYY-MM-DD");
}
